import React from 'react';
import styles from "./styles.module.scss";
import cn from "classnames";

const Index = ({children, onClick, fullWidth, disabled}) => {
  return (
    <button
      className={cn(styles["btn"],
        {[styles["fullwidth"]]: fullWidth},
        {[styles["disabled"]]: disabled})} onClick={onClick}>
      {children}
    </button>
  );
};

export default Index;